/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-08
 */

import React, {Component} from 'react';
import SyllabusPage from '../syllabus/SyllabusPage';
import UsersList from '../users/UsersList';
import VersionList from '../syllabus/VersionList';
import UsersPage from '../users/UsersPage';
import SetList from '../syllabus/SetList';
import Error from '../widgets/Error';
import Spine from './Spine';
import {Route, Switch} from 'react-router';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {actions} from '../session.state';
import jsonFetch from '../jsonFetch';
import handleError from '../handleError';
import NotFound from '../widgets/NotFound';
import {admin_syllabus, admin_user} from '../permissions';

/**
 * Match all invalid paths, so we can show a NotFound component
 */
const CATCH_ALL = /^\/(?!(user|set)).+$/igm;

/**
 * Where the actual app is mounted into when a valid session is confirmed.
 *
 * Hoisted session checking up to App level, rather than just Spine. So routes don't render if there's no valid session
 */
export class Chrome extends Component {
	constructor(props) {
		super(props);
		
		this.fetcher = props.fetcher || jsonFetch;
		this.storage = props.storage || localStorage;
		
		// Re-direct to login page on load if no token set
		if (!this.storage.getItem('token')) {
			this.logout();
		}
		// Attempt session load
		const email = this.storage.getItem('email');
		
		if (email && email !== 'undefined') {
			// Request current user credentials on initial load
			this.fetcher(`${process.env.REACT_APP_API}/user/${email}`)
				.then(json => props.sessionSet(json))
				.catch(props.handleInitialCheckError);
		} else {
			this.logout();
		}
	}

	logout = () => {
		const { sessionClear, redirectLoggedout } = this.props;
		sessionClear();
		this.storage.clear();
		redirectLoggedout();
	};
	
	render() {
		const {session} = this.props;
		
		// Only render if we have a valid session
		if (!session) return null;
		
		const canAdminUser = session && session.permissions && session.permissions.indexOf(admin_user) >= 0;
		const canAdminSyllabus = session && session.permissions && session.permissions.indexOf(admin_syllabus) >= 0;
		
		return (
			<div className="App Chrome">
				<Error />
				<Spine logout={this.logout} />
				
				<Route path="/user" component={canAdminUser ? UsersList : NotFound}/>
				<Route path="/user/:email" component={canAdminUser ? UsersPage : null}/>
				
				{/* Syllabus page nav tree*/}
				<Switch>
					{/*The switch ensures no more than one of these is rendered (or none) and components are re-used*/}
					<Route path="/" exact component={canAdminSyllabus ? SetList : null} />
					<Route path="/set" component={canAdminSyllabus ? SetList : NotFound} />
				</Switch>
				<Route path="/set/:setID" component={canAdminSyllabus ? VersionList : null} />
				<Switch>
					{/*The switch ensures no more than one of these is rendered (or none) and components are re-used*/}
					<Route path="/set/:setID" exact component={canAdminSyllabus ? SyllabusPage : null} />
					<Route path="/set/:setID/version/:versionID" component={canAdminSyllabus ? SyllabusPage : null} />
				</Switch>
				
				<Route path={CATCH_ALL} component={NotFound} />
			</div>
		);
	}
}

const ConnectedChrome = connect(
	state => ({
		session: state.session
	}),
	dispatch => ({
		sessionSet: data => dispatch(actions.sessionSet(data)),
		sessionClear: () => dispatch(actions.sessionClear()),
		redirectLoggedout: () => dispatch(push('/loggedout')),
		handleError: handleError(dispatch),
		handleInitialCheckError: handleError(dispatch, false, true)
	})
)(Chrome);

export default ConnectedChrome;



// WEBPACK FOOTER //
// ./src/chrome/Chrome.js